import { Container, Typography, Box } from "@mui/material";
import React, { useState } from "react";
//import { useTranslation } from 'react-i18next';
import Header from "../components/common/Header";
import configData from "../Config";
import ErrorAnimation from "../components/Lottie/ErrorAnimation";
import SubmitButton from "../components/common/SubmitButton";
import { useLocation, useNavigate } from "react-router-dom";
import { apis } from "../services/apiService";

export default function ErrorMessage() {
  const [loading, setLoading] = useState(false);
  let location = useLocation();
  const navigate = useNavigate();
  window.history.forward();
  //const { H, Disc } = useParams();
  //const { Head, setHeader } = useState("EE");
  //const { t } = useTranslation();
  //let handleSubmit = async (e) => {
  //    e.preventDefault();
  //    navigate( location.state.H , { state: data });
  //};
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     let data = { aid: location.state.AppId };
  //     navigate("/loading", { state: data });
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = () => {
    let data = { AppId: location?.state?.AppId };
    navigate("/loading", { state: data });
  };

  return (
    <Container maxWidth={false} className="container_Th">
      <Header showBar={false} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <ErrorAnimation />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h2" color="primary" sx={{ mt: 1, mb: 2 }}>
            {/*{t(*/}
            {/*    'ERROR'*/}
            {/*)}*/}
            {location?.state?.H}
          </Typography>
          <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
            {/*{t(*/}
            {/*  'Error Details'*/}
            {/*          )}*/}
            {location?.state?.Disc}
          </Typography>
          <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
            {/*{t(*/}
            {/*  'Error Details'*/}
            {/*          )}*/}
            {location?.state?.otherMSG}
          </Typography>
        </Box>
      </Box>
      {location?.state?.Retry && (
        <Box onClick={handleSubmit}>
          <SubmitButton hasNote="No" displayVal="Retry" />
        </Box>
      )}
    </Container>
  );
}
